import React from 'react';
import textService from '../../services/text';
import Title from '../title/title';
import './menu.scss';

const Menu = () => {
  const panes = textService.getPanes();

  return (
    <section className="menu-section">
      <Title myTitle={textService.getPanesTitle()} />
      
      <div className="menu-info">
        <p className="menu-description">
          Todos nuestros panes están hechos con masa madre natural y ingredientes frescos. 
          Los pedidos se realizan <strong>antes del martes</strong> y las entregas son jueves y viernes.
        </p>
      </div>

      <div className="menu-list">
        {panes.map(pane => (
          <div key={pane.id} className="menu-item">
            <div className="menu-item-content">
              <div className="menu-item-header">
                <h3 className="menu-item-name">{pane.name}</h3>
                <span className="menu-item-price">{pane.price}</span>
              </div>
              <p className="menu-item-ingredients">{pane.ingredients}</p>
              {pane.description && (
                <p className="menu-item-ingredients">{pane.description}</p>
              )}
              <div className="menu-item-badge">
                <span className="badge-text">Masa Madre Natural</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="menu-footer">
        <div className="order-info">
          <h4>¿Cómo hacer tu pedido?</h4>
          <div className="order-steps">
            <div className="step">
              <div className="step-number">1</div>
              <p>Envía tu pedido por WhatsApp o email <strong>antes del martes</strong></p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <p>Confirmamos tu pedido y te damos detalles de entrega</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <p>Recibes tu pan fresco jueves o viernes</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;